module.exports = "/images/vendor/flag-icon-css/flags/4x3/sx.svg?522d898c19396a45caa51ed0f0f2543e";